import WT1 from '../../../media/GW/WT.webp'
import WT2 from '../../../media/GW/WT.webp'


const WTimages =[
WT1,WT2
]

export default WTimages;